import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';

const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    return {
        headers: {
            Authorization: `Bearer ${token}`
        }
    };
};

// Get all tutors for the current center
export const getTutors = async () => {
    const response = await axios.get(`${API_URL}/tutors`, getAuthHeaders());
    return response.data;
};

// Create a tutor profile for a user
export const createTutorProfile = async (userId, profileData) => {
    const response = await axios.post(
        `${API_URL}/tutors/${userId}/profile`,
        profileData,
        getAuthHeaders()
    );
    return response.data;
};

// Get tutor profile by user ID
export const getTutorProfile = async (userId) => {
    const response = await axios.get(
        `${API_URL}/tutors/${userId}/profile`,
        getAuthHeaders()
    );
    return response.data;
};

// Update tutor profile
export const updateTutorProfile = async (userId, profileData) => {
    const response = await axios.put(
        `${API_URL}/tutors/${userId}/profile`,
        profileData,
        getAuthHeaders()
    );
    return response.data;
};

// Delete tutor profile
export const deleteTutorProfile = async (userId) => {
    const response = await axios.delete(
        `${API_URL}/tutors/${userId}/profile`,
        getAuthHeaders()
    );
    return response.data;
};

// Get students for a specific tutor
export const getTutorStudents = async (tutorUserId) => {
    const response = await axios.get(
        `${API_URL}/tutors/${tutorUserId}/students`,
        getAuthHeaders()
    );
    return response.data;
};

// Get classes for a specific student of a specific tutor
export const getTutorStudentClasses = async (tutorUserId, studentUserId) => {
    const response = await axios.get(
        `${API_URL}/tutors/${tutorUserId}/students/${studentUserId}/classes`,
        getAuthHeaders()
    );
    return response.data;
};

// Get all classes for a specific tutor
export const getTutorClasses = async (tutorUserId) => {
    const response = await axios.get(
        `${API_URL}/tutors/${tutorUserId}/classes`,
        getAuthHeaders()
    );
    return response.data;
};

const tutorService = {
    getTutors,
    createTutorProfile,
    getTutorProfile,
    updateTutorProfile,
    deleteTutorProfile,
    getTutorStudents,
    getTutorStudentClasses,
    getTutorClasses
};

export default tutorService;
